import { jsx as _jsx, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../../hooks/redux/index.js';
import { errorStatusSelector } from '../appleUpdateEmailSlice.js';
export const AppleUpdateFailedAlert = () => {
    const { t } = useTranslation();
    const errorStatus = useAppSelector(errorStatusSelector); // 400 409 500
    const errorMap = {
        400: '400',
        409: '409',
        500: '500',
    };
    const code = errorStatus && errorMap?.[errorStatus] ? errorMap?.[errorStatus] : 500;
    const errorMessage = t(`loginregistration.twoStepLoginRegistration.appleUpdateEmail.error.${code}`);
    return (_jsx(_Fragment, { children: errorStatus && (_jsx(Alert, { variant: 'negative', role: 'alert', children: errorMessage })) }));
};
//# sourceMappingURL=AppleUpdateFailedAlert.js.map